import { AxiosResponse } from "axios";

import API from "../api";

const ROUTE_NAME = "upload";

interface UploadFile {
  filename: string;
  uri?: string;
}
interface UploadFileResponse extends Omit<UploadFile, "uri"> {
  url: string;
}

const UploadService = {
  async uploadFile(fileInfos: UploadFile): Promise<AxiosResponse<UploadFileResponse>> {
    return await API.post(`/${ROUTE_NAME}/file`, fileInfos);
  },
  async deleteFile(filename: string): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/file/${filename}`);
  },
};

export default UploadService;
